import React, { useEffect, useState } from "react";
import axios from "axios";
import { GET_PRODUCTS, SHOW_PRODUCTS, APP_BASE_URL, ADD_CART_PRODUCTS, DELETE_CART_PRODUCTS, GET_CART_PRODUCTS, PURCHASE_PRODUCTS, GET_GRANTED_PRODUCTS, GET_REQUESTED_PRODUCTS } from "../../AppConstant";
import { Modal, Button } from "react-bootstrap";

import LoadingGif from "../../../assets/images/Spin_loader.gif"
import { Input } from "@mui/material";


function Products({ setParentLoading }) {

    const rmemail = localStorage.getItem("rmemail");

    console.log("reportingmanageremail", rmemail);

    const [isChecked, setIsChecked] = useState(false);
    const [productsLoaded, setProductsLoaded] = useState(false);

    // TO SHOW THE TOTAL PRODUCTS AVAILABLE 
    const [products, setProducts] = useState(null);

    // TO SEE IF THE USER IS CHOOSEN THE PRODUCTS (USED TO -> STORE THE ID)
    const [cartProducts, setCartProducts] = useState([]);

    // TO SHOW THE COUNT AT THE CART
    const [cartCount, setCartCount] = useState(0);

    // TO OPEN AND CLOSE THE MODAL OF THE CART
    const [showCartModal, setShowCartModal] = useState(false);
    const [showFAQModal, setShowFAQModal] = useState(false);

    // TO SHOW THE ITEM IN THE CART BEFORE SUBMIT
    const [cartItems, setCartItems] = useState([]);

    const [errorMessage, setErrorMessage] = useState("");

    const [error, setError] = useState("");

    const [grantedProducts, setGrantedProducts] = useState([]);
    const [requestedProducts, setRequestedProducts] = useState([]);

    const [submit, setSubmit] = useState(false);

    // const [loading, setLoading] = useState(false);


    const AddToCart = async (id) => {
        try {

            setParentLoading(true);

            const empid = localStorage.getItem("empid");

            if (cartProducts.length >= 1) {
                setErrorMessage("Only one product allowed per request");
                setTimeout(() => {
                    setParentLoading(false);
                }, 500);
                return;
            }

            const res = await axios.post(ADD_CART_PRODUCTS, {
                id,
                empid
            });

            console.log(res.data);

            fetchCartProducts();
            setErrorMessage("");

            setTimeout(() => {
                setParentLoading(false);
            }, 500);

        } catch (err) {
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            console.error(err);
        }
    };

    const RemoveFromCart = async (id) => {
        try {
            setParentLoading(true);

            const empid = localStorage.getItem("empid");

            await axios.post(DELETE_CART_PRODUCTS, {
                id,
                empid
            });

            fetchCartProducts();
            setErrorMessage("");

            setTimeout(() => {
                setParentLoading(false);
            }, 500);


        } catch (err) {
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            console.error(err);
        }
    };

    const handleOpenCart = async () => {
        setParentLoading(true);
        setShowCartModal(true);
        fetchCartProducts();
        setErrorMessage("");
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const handleCloseCart = () => {
        setParentLoading(true);
        setShowCartModal(false);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

     const handleOpenFAQ = async () => {
        setParentLoading(true);
        setShowFAQModal(true);
        setErrorMessage("");
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const handleCloseFAQ = () => {
        setParentLoading(true);
        setShowFAQModal(false);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const handleCloseSubmit = () => {
        setParentLoading(true);
        setSubmit(false);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);

    }

    //  SHOW THE OVERALL PRODCTS AVAILABLE
    const showProducts = async () => {
        try {
            setParentLoading(true);

            const res = await axios.get(GET_PRODUCTS);

            const products = res.data;

            const imagePromises = products.map((item) => {
                return new Promise((resolve) => {
                    const img = new Image();

                    img.onload = resolve;
                    img.onerror = resolve;

                    img.src = `${APP_BASE_URL}/products/getproductimage/${item.id}`;
                });
            });

            await Promise.all(imagePromises);

            setProducts(products);
            setProductsLoaded(true);

            setTimeout(() => {
                setParentLoading(false);
            }, 500);

        } catch (err) {
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            console.error(err);
        }
    };

    // FETCH THE PRODUCTS USER CHOOSEN IN THE CART
    const fetchCartProducts = async () => {
        try {
            setParentLoading(true);
            const empid = localStorage.getItem("empid");

            const res = await axios.get(GET_CART_PRODUCTS, {
                params: { empid }
            });

            setCartItems(res.data);

            const cartIds = res.data.map(item => item.product_id);

            setCartProducts(cartIds);

            setCartCount(cartIds.length);

            setTimeout(() => {
                setParentLoading(false);
            }, 500);

        } catch (err) {
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            console.error(err);
        }
    };

    //  FETCH ALREADY GRANTED PRODUCTS
    const fetchGrantedProducts = async () => {
        try {
            setParentLoading(true);
            const empid = localStorage.getItem("empid");

            const res = await axios.get(GET_GRANTED_PRODUCTS, {
                params: { empid }
            });

            const ids = res.data.map(item => item.product_id);
            setGrantedProducts(ids);

            setTimeout(() => {
                setParentLoading(false);
            }, 500);

        } catch (err) {
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            console.error(err);
        }
    };

    // FETCH ALREADY REQUESTED PRODUCTS
    const fetchRequestedProducts = async () => {
        try {
            setParentLoading(true);

            const empid = localStorage.getItem("empid");

            const res = await axios.get(GET_REQUESTED_PRODUCTS, {
                params: { empid }
            });

            // const ids = res.data
            //     .filter(item => item.status === "T"  || item.status === "A")
            //     .map(item => item.product_id);

            setRequestedProducts(res.data); // store full data

            // setRequestedProducts(ids);

            setTimeout(() => {
                setParentLoading(false);
            }, 500);

        } catch (err) {
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            console.error(err);
        }
    };

    useEffect(() => {
        if (productsLoaded) {
            setParentLoading(false);
        }
    }, [productsLoaded]);


    useEffect(() => {
        showProducts();
        fetchCartProducts();
        fetchGrantedProducts();
        fetchRequestedProducts();

    }, []);

    const RequestProducts = async () => {
        try {
            setParentLoading(true);

            const empid = localStorage.getItem("empid");

            const empname = localStorage.getItem("empname");
            const empemail = localStorage.getItem("emailid");
            const rmemail = localStorage.getItem("rmemail");

            console.log(rmemail);

            if (rmemail === null || rmemail == "" || rmemail == "null") {
                setErrorMessage("You have no Reporting Manager. Please contact IT team.")
                setTimeout(() => {
                    setParentLoading(false);
                }, 500);
                return;
            }

            const payload = {
                empid: empid,
                empname: empname,
                empemail: empemail,
                products: cartItems.map(item => ({
                    id: item.product_id,
                    functionalhead: rmemail
                }))
            };

            const res = await axios.post(PURCHASE_PRODUCTS, payload);

            console.log(res.data);

            fetchCartProducts();

            fetchGrantedProducts();
            fetchRequestedProducts();


            handleCloseCart();
            setErrorMessage("");


            setSubmit(true);

            setTimeout(() => {
                setParentLoading(false);
            }, 500);


        } catch (err) {
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            console.error(err);
        }
    };

    // const isStatusA = (id) =>
    // requestedProducts.some(item => item.product_id === id && item.status === "A");

    const isRequested = (id) =>
        requestedProducts.some(item => item.product_id === id && item.status === "T");

    const hasAnyStatusA = requestedProducts.some(item => item.status === "A");

    const hasAnyStatusT = requestedProducts.some(item => item.status === "T");

    return (
        <>
            <div className="m-2" style={{ textAlign: "end" }}>

                <h3 className="cart-card btn btn-light rounded-pill fw-bold"
                    style={{color:"green"}} onClick={handleOpenFAQ} title="Terms & Conditions">
                    <i className="bi bi-journal-text"></i>
                </h3>
                &nbsp;
                <h3
                    className="cart-card btn btn-light rounded-pill fw-bold"
                    style={{ color: "green" }} onClick={handleOpenCart} title="Cart"
                >
                    <span className="position-relative d-inline-block pt-1">
                        <i className="bi bi-cart4"></i>

                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                            {cartCount}
                        </span>
                    </span>
                </h3>
            </div>

            {errorMessage && (
                <p style={{ color: "red", marginTop: "5px" }}>
                    {errorMessage}
                </p>
            )}

            <div className="container-fluid mt-1">
                <div className="row">


                    {products === null ? <div className="text-center mt-4">
                        <h6 style={{ color: "white", fontWeight: "bold", fontSize: "20px" }}> Loading Products please be patient....</h6>
                    </div> : (
                        products.length > 0 ? (
                            products.map((item) => (
                                <div
                                    key={item.id}
                                    className="col-6 col-md-4 col-lg-3 col-xl-2 mb-3"
                                >
                                    <div className="card border border-1 border-info product-card shadow-sm h-100 border-0">

                                        {/* IMAGE CONTAINER */}
                                        <div className="image-wrapper">
                                            <img
                                                src={`${APP_BASE_URL}/products/getproductimage/${item.id}`}
                                                alt={item.name}
                                                className="product-img"
                                            />
                                        </div>

                                        {/* PRODUCT NAME */}
                                        <div className="card-body border border-1 border-info text-center p-2">
                                            <h6 className="fw-bold text-dark mb-1">
                                                {item.name}
                                            </h6>
                                        </div>

                                        <div className="card-body border border-info text-center p-1">

                                            {isRequested(item.id) ? (

                                                /* 2. Already Requested */
                                                <p
                                                    className="m-0"
                                                    style={{ fontWeight: "bold", fontSize: "10px", color: "orange" }}
                                                >
                                                    THIS PRODUCT IS IN REQUEST
                                                </p>

                                            ) :
                                                hasAnyStatusA ? (

                                                    // FIRST PRIORITY: Status = A
                                                    <p
                                                        className="m-0"
                                                        style={{ fontWeight: "bold", fontSize: "10px", color: "red" }}
                                                    >
                                                        ACKNOWLEDGE FIRST
                                                    </p>

                                                ) :
                                                    hasAnyStatusT ? (

                                                        //  ONLY ONE REQUEST : Status = T
                                                        <p
                                                            className="m-0"
                                                            style={{ fontWeight: "bold", fontSize: "10px", color: "red" }}
                                                        >
                                                            ONLY ONE REQUEST ALLOWED
                                                        </p>

                                                    ) :

                                                        item.count == 0 ? (<p
                                                            className="m-0"
                                                            style={{ fontWeight: "bold", fontSize: "10px", color: "orange" }}
                                                        >
                                                            OUT OF STOCK
                                                        </p>) :
                                                            (

                                                                <>
                                                                    {/* 1. Already Purchased */}
                                                                    {grantedProducts.includes(item.id) ? (
                                                                        <p
                                                                            className="m-0"
                                                                            style={{ fontWeight: "bold", fontSize: "10px", color: "green" }}
                                                                        >
                                                                            ALREADY PROVIDED
                                                                        </p>

                                                                    ) : cartProducts.includes(item.id) ? (

                                                                        /* 3. Remove */
                                                                        <p
                                                                            className="m-0 btn btn-danger btn-sm"
                                                                            style={{ fontWeight: "bold", fontSize: "10px" }}
                                                                            onClick={() => RemoveFromCart(item.id)}
                                                                        >
                                                                            REMOVE
                                                                        </p>

                                                                    ) : (

                                                                        /* 4. Add */
                                                                        <p
                                                                            className="m-0 btn btn-success btn-sm"
                                                                            style={{ fontWeight: "bold", fontSize: "10px" }}
                                                                            onClick={() => AddToCart(item.id)}
                                                                        >
                                                                            ADD TO CART
                                                                        </p>
                                                                    )}
                                                                </>
                                                            )}

                                        </div>




                                    </div>


                                </div>
                            ))
                        ) : (
                            <div className="text-center mt-4">
                                <h6> No products available</h6>
                            </div>
                        ))}

                </div>
            </div>



            {/* CART MODAL */}
            <Modal
                show={showCartModal}
                onHide={handleCloseCart}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header style={{ justifyContent: "center" }}>
                    <Modal.Title style={{ color: "green", fontWeight: "bold", textAlign: "center" }}>My Cart</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {cartItems.length > 0 ? (
                        cartItems.map((item) => (
                            <div key={item.product_id} className="d-flex align-items-center mb-2">
                                <img
                                    src={`${APP_BASE_URL}/products/getproductimage/${item.product_id}`}
                                    alt={item.product_name}
                                    style={{ width: "40px", height: "40px", marginRight: "10px" }}
                                />
                                <span style={{ fontWeight: "bold" }}>{item.product_name}</span>

                                <p
                                    className="ms-auto m-0 btn btn-danger btn-sm"
                                    style={{ fontWeight: "bold", fontSize: "10px" }}
                                    onClick={() => RemoveFromCart(item.product_id)}
                                >
                                    REMOVE
                                </p>


                            </div>
                        ))
                    ) : (
                        <p>No items in cart</p>
                    )}
                </Modal.Body>

                <p className="fw-bold text-center" style={{ color: "red", fontSize: "small" }}>{errorMessage}</p>
              

                <Modal.Footer>

 <div className="d-flex align-items-center">
    <input
        className="form-check-input"
        type="checkbox"
        id="termsCheck"
        style={{
            border: "1px solid black",
            width:"10px"
        }}
        checked={isChecked}
        onChange={(e) => setIsChecked(e.target.checked)}
    />

    <label
        className="mb-0"
        htmlFor="termsCheck"
        style={{ cursor: "pointer", color:"blue" }}
    >
        I have read and agree to the Terms and Conditions
    </label>
</div>

                    <Button variant="secondary" onClick={handleCloseCart}>
                        Close
                    </Button>

                    {cartItems.length > 0 ? (<Button variant="success" onClick={RequestProducts} disabled={!isChecked}>
                        Submit
                    </Button>) : null}

                </Modal.Footer>
            </Modal>

            {/* FAQ MODAL */}
              <Modal  className="modal modal-lg"
                show={showFAQModal}
                onHide={handleCloseFAQ}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header style={{ justifyContent: "center" }}>
                    <Modal.Title style={{ color: "green", fontWeight: "bold", textAlign: "center" }}>User Responsibilities & Liabilities</Modal.Title>
                </Modal.Header>

                   <Modal.Body className="text-secondary">

    <p>
        By ordering accessories through the IT Accessories Self-Service Portal,
        the employee agrees to the following terms and conditions:
    </p>

    <h5 className="text-primary fw-bold">1. Usage Responsibility</h5>
    <ul>
        <li>IT accessories issued through the IT Accessories Self-Service Portal are provided strictly for official business purposes.</li>
        <li>Employees shall use the issued accessories in accordance with company policies, Information Security requirements, and Asset Management guidelines.</li>
        <li>Personal use, unauthorized sharing, modification, or misuse of company-issued accessories is strictly prohibited.</li>
    </ul>

    <h5 className="text-primary fw-bold">2. Office Usage Policy</h5>
    <ul>
        <li>IT accessories provided by the company are intended primarily for use within authorized company office premises and for approved business activities.</li>
        <li>Employees are responsible for ensuring that issued accessories are used only for legitimate business requirements and are safeguarded against misuse, loss, or unauthorized access.</li>
        <li>Use of company-issued accessories for personal purposes, non-business activities, or in any unauthorized environment is prohibited unless expressly approved by the IT Department and Management.</li>
        <li>If an issued accessory is found to be used for personal purposes or in violation of company policies, the company reserves the right to:</li>
        <ul>
            <li>Recall and recover the accessory immediately.</li>
            <li>Revoke the employee's eligibility to request IT accessories in the future.</li>
            <li>Suspend or permanently disable access to company-provided systems and services, including Switch Gear access, subject to management approval.</li>
            <li>Initiate disciplinary action in accordance with company policies.</li>
        </ul>
    </ul>

    <h5 className="text-primary fw-bold">3. Asset Care & Responsibility</h5>
    <p>Employees are responsible for:</p>
    <ul>
        <li>Proper handling, maintenance, and care of all issued accessories.</li>
        <li>Protecting accessories from damage, loss, misuse, or theft.</li>
        <li>Using accessories in compliance with company policies and security requirements.</li>
        <li>Immediately reporting any damage, loss, theft, or malfunction to the IT Service Desk.</li>
    </ul>

    <h5 className="text-primary fw-bold">4. Loss, Theft, or Damage Policy</h5>
    <p>In the event of loss, theft, or physical damage to an issued accessory:</p>
    <ul>
        <li>Employees must notify the IT Service Desk and their reporting manager immediately.</li>
        <li>IT may conduct an assessment to determine the nature and cause of the incident.</li>
        <li>Where negligence, misuse, unauthorized handling, or policy violation is established, the employee may be held liable for the applicable recovery cost as determined by the company.</li>
        <li>Replacement of lost or damaged accessories shall be subject to management approval and company policy.</li>
        <li>Repeated incidents may result in restriction of future accessory requests and additional disciplinary action.</li>
    </ul>

    <h5 className="text-primary fw-bold">5. Return of Accessories</h5>
    <p>
        All IT accessories issued through the portal remain company property and
        must be returned to the IT Department under the following circumstances:
    </p>

    <h6 className="text-primary fw-bold">Mandatory Return</h6>
    <ul>
        <li>During resignation, retirement, or separation from the organization.</li>
        <li>During departmental or role changes where the accessory is no longer required.</li>
        <li>Upon IT or management request.</li>
        <li>During asset audits or verification exercises.</li>
    </ul>

    <h6 className="text-primary fw-bold">Return Condition</h6>
    <ul>
        <li>Accessories must be returned in reasonable working condition, considering normal wear and tear.</li>
        <li>Any missing components, deliberate damage, or unreported defects may be subject to recovery as per company policy.</li>
    </ul>

    <h5 className="text-primary fw-bold">6. Employee Purchase of Issued Accessories</h5>
    <p>
        In exceptional circumstances, employees may request to purchase an assigned
        accessory instead of returning it.
    </p>
    <ul>
        <li>Such requests shall be reviewed on a case-by-case basis.</li>
        <li>The recoverable value of the asset shall be determined by the company based on the asset's age, depreciation, condition, and residual value.</li>
        <li>Ownership transfer shall occur only after:</li>
        <ul>
            <li>All approvals have been obtained.</li>
            <li>The recovery amount has been successfully collected.</li>
            <li>Formal asset transfer documentation has been completed.</li>
        </ul>
        <li>Until the transfer process is completed, the asset shall remain company property.</li>
    </ul>

    <h5 className="text-primary fw-bold">7. Compliance & Audit</h5>
    <ul>
        <li>All accessory requests, approvals, issuances, transfers, returns, and recoveries are recorded and maintained for audit purposes.</li>
        <li>Employees may be required to present issued accessories during periodic asset audits conducted by IT, Internal Audit, or Management.</li>
        <li>Failure to comply with asset management policies may result in recovery actions, suspension of privileges, access restrictions, and disciplinary action as per company policy.</li>
    </ul>

    <h5 className="text-primary fw-bold">Employee Acknowledgement</h5>
    <p>
        By submitting an IT Accessories request through the portal, the employee
        acknowledges that all issued accessories remain company property, agrees
        to use them solely for authorized business purposes, and accepts
        responsibility for their care, return, and compliance with all applicable
        company policies.
    </p>

                </Modal.Body>

                <Modal.Footer>

                    <Button variant="secondary" onClick={handleCloseFAQ}>
                        Close
                    </Button>

                </Modal.Footer>
            </Modal>

            {/* SUBMIT MODAL */}
            <Modal className="mt-5"
                show={submit}
                onHide={handleCloseSubmit}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <h6 style={{ color: "green", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                        Request Submitted. Check status in STATUS tab.
                        <p
                            className="btn btn-close ms-auto"
                            onClick={handleCloseSubmit}
                        >
                        </p>
                    </h6>
                </Modal.Header>
            </Modal>


        </>
    );
}

export default Products;